<template>
  <div>
    <!-- 当前层级是最后一级时显示 el-input -->
    <template v-if="isLastLevel">
      <el-date-picker class="shuxing_input" v-if="data.oneOfValue != null && data.oneOfValue == 'date'"
        v-model="data.value" :placeholder="'请选择' + data.titleChinese" format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-input :disabled="isChakan || system < 5"
        v-else-if="data.enumValue == null && data.type == 'string' || data.type == 'array'" class="shuxing_input"
        autosize :placeholder="'请输入' + data.titleChinese" v-model="data.value" show-word-limit
        :type="data.maxLength == null ? 'input' : 'textarea'" :maxlength="data.maxLength">
      </el-input>
      <el-input :disabled="isChakan || system < 5"
        v-else-if="data.type == 'integer' || data.type == 'number' && data.enumValue == null" class="shuxing_input"
        autosize :placeholder="'请输入' + data.titleChinese" v-model="data.value" show-word-limit type="number"
        :max="data.maximum" @input="numberInput(data)" :maxlength="data.maxLength">
      </el-input>
      <el-select :router="true" class="shuxing_input" v-else-if="data.property != 'marketplace_id'" v-model="data.value"
        clearable filterable :placeholder="'请选择' + data.titleChinese">
        <el-option v-for="selectItem in data.enumValue" :key="selectItem" :label="selectItem" :value="selectItem">
        </el-option>
      </el-select>
    </template>
    <!-- 如果有子级，递归渲染子组件 -->
    <template v-else>
      <div v-for="child in data.children" :key="child.id">
        <recursive-input :key="child.id" :data="child" :isChakan="isChakan" :system="system"
          :parent="data"></recursive-input>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "RecursiveInput",
  props: {
    data: {
      type: Object,
      required: true,
    },
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
    parent: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
    };
  },
  computed: {
    // 判断当前层级是否为最后一级
    isLastLevel() {
      if(!this.data.children || this.data.children.length === 0){
        // console.log(this.data, this.data.property);
      }
      if (!this.data.children || this.data.children.length === 0) {
        if (JSON.parse(sessionStorage.getItem('list_priceNum')) != null) {
          const listPriceNum = JSON.parse(sessionStorage.getItem('list_priceNum'));
          if (this.data.value === '' || this.data.value === ' ' || this.data.value === null || this.data.value === undefined) {
            this.$set(this.data, 'value', listPriceNum[this.data.property]);
          }
        }
      }
      return !this.data.children || this.data.children.length === 0;
    },
  }
  ,
  methods: {
    numberInput(items) {
      if (items.maximum != null) {
        if (parseFloat(items.value) > items.maximum) {
          items.value = items.maximum;
        }
      }
    },
  },
};
</script>

<style scoped>
.shuxing_input {
  width: 100%;
  padding: 5px 0px;
}
</style>
